import { memo, useMemo } from 'react';
import { Box, Icon, Text } from '@bonanza-social/moonlight';
import { RewardBadgeProps } from './RewardBadge.types';
import { rewardBadgeDataMap } from './RewardBadge.constants';
import { formatAmount } from '@bonanza-social/toolkit/utils';

function RewardBadge({ rewards, isReferral }: RewardBadgeProps) {
  const filteredRewards = useMemo(
    () => rewards.filter((reward) => reward.rewardAmount > 0),
    [rewards],
  );

  return (
    <Box
      flexDirection="row"
      flexWrap="wrap"
      gap="space-200"
      marginBottom="space-300"
    >
      <Text
        variant="body-s"
        color="darkSurfacePrimary"
        locNS="registration"
        locKey={isReferral ? 'offerReg' : 'Get'}
      ></Text>
      {filteredRewards.map((reward, i) => (
        <Box key={i}>
          {rewardBadgeDataMap[reward.rewardTarget] ? (
            <Box flexDirection="row" gap="space-100" alignItems="center">
              <Icon
                name={rewardBadgeDataMap[reward.rewardTarget].iconName}
                gradient="accentBackground"
                width="space-500"
                height="space-500"
              />
              <Text variant="body-s-semi" color="darkSurfacePrimary">
                {formatAmount(reward.rewardAmount)}
              </Text>
              <Text variant="body-s-semi" color="darkSurfacePrimary">
                {rewardBadgeDataMap[reward.rewardTarget].rewardName}
              </Text>
            </Box>
          ) : null}
        </Box>
      ))}
    </Box>
  );
}

export default memo(RewardBadge);
